export const Colors={
  primary:'#2490ff',
  secondary:'#0e233c',
  muted:'#6c757d'
};

